import { render, staticRenderFns } from "./ubahpassword.vue?vue&type=template&id=24857a4a&"
import script from "./ubahpassword.vue?vue&type=script&lang=js&"
export * from "./ubahpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports